import { Template } from '../services/TemplateService/Template.type';
import useAutosaveTemplate from './useAutosaveTemplate';
import useEndGame from './useEndGame';
import usePresent from './usePresent';

const useEndAndStartNewLesson = () => {
  const { end, endResultIsLoading } = useEndGame();

  const { presentLesson, isCreatingGame } = usePresent();
  const { autoSaveTemplate } = useAutosaveTemplate();

  const handleEndAndStartNewLesson = async ({
    gameId,
    template,
  }: {
    gameId: string;
    template: Template;
  }) => {
    // First we end the current game
    await end({ gameId });

    // Then we present a new lesson with the same template.
    await presentLesson({
      method: 'present',
      gameId: null, // Must be null
      fromBeginning: true,
      template: { ...template, content: { ...template.content, activeGame: null } }, // Make sure activeGame is null to create a new game
      callbackBeforeRedirect: gameId => {
        // Must set the new active game when this is done. In react query cache.
        autoSaveTemplate({
          templateConfig: {
            activeGame: {
              id: gameId,
              isOngoing: false,
            },
            modifiedAt: new Date().getTime(),
            id: template.id,
          },
        });
      },
    });
  };

  return {
    handleEndAndStartNewLesson,
    isLoading: isCreatingGame || endResultIsLoading,
  };
};

export default useEndAndStartNewLesson;
